// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__-KVQ9","filters_close":"FiltersBlock_filters_close__N+MIs"};